import { createSlice } from '@reduxjs/toolkit';

import { IMaterialsState } from './interfaces';
import { loadMaterial, loadMaterialsList } from './actions';

export const materialsSlice = createSlice({
  name: 'materials',
  initialState: {
    list: [],
    item: {},
    limit: 20,
    total: 0,
    offset: 0,
  } as IMaterialsState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadMaterialsList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(loadMaterial.fulfilled, (state, { payload }) => {
      state.item = payload;
    });
  },
});
